<h1 class="center"> Gestion des données statistiques </h1>

<div class="statsLH-page">
	<div class="clamp-commande" [formGroup]="control">
		<div class="entete">
			<button mat-raised-button routerLink="../historique">
				Historiques
			</button>
			<mat-form-field>
				<mat-select placeholder="Année" formControlName="annee">
					<mat-option *ngFor="let annee of listAnnee" [value]="annee">
						{{ annee }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field *ngIf="isLingerie">
				<mat-select placeholder="Mois" formControlName="mois">
					<mat-option *ngFor="let mois of listMois" [value]="mois">
						{{ mois }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<table class="styled-table">
			<thead>
				<tr>
					<th *ngIf="!isLingerie">Mois</th>
					<th *ngIf="isLingerie">Lingerie</th>
					<th style="width: 0%;" *ngIf="isHotel">Nombre de chambres</th>
					<th style="width: 0%;" *ngIf="isSante">Nombre de lits</th>
					<th style="width: 0%;" *ngIf="isHotel">Nombre de nuitées *</th>
					<th style="width: 0%;" *ngIf="!isHotel">Jour d'activités *</th>
				</tr>
			</thead>
			<tbody *ngIf="isLingerie">
				<tr *ngFor="let lingerie of lingeries">
					<td>{{ lingerie.libelle }}</td>
					<td *ngIf="isSante || isHotel">
						<mat-form-field>
							<mat-label></mat-label>
							<input type="number" matInput [value]="getEmplacementsLingerie(lingerie.id)"
								(change)="updateLingerie(lingerie.id, $event, false)" #txtInput
								(keydown.enter)="txtInput.blur()">
						</mat-form-field>
					</td>
					<td>
						<mat-form-field>
							<mat-label></mat-label>
							<input type="number" matInput [value]="getJoursLingerie(lingerie.id)" min=0 max=31
								(change)="updateLingerie(lingerie.id, $event, true)" #txtInput
								(keydown.enter)="txtInput.blur()">
						</mat-form-field>
					</td>
				</tr>
			</tbody>
			<tbody *ngIf="!isLingerie">
				<tr *ngFor="let mois of listMois">
					<td>{{ mois }}</td>
					<td *ngIf="isSante || isHotel">
						<mat-form-field>
							<mat-label></mat-label>
							<input type="number" matInput [value]="getEmplacements(mois)" min=0
								(change)="update(mois, $event, false)" #txtInput (keydown.enter)="txtInput.blur()">
						</mat-form-field>
					</td>
					<td>
						<mat-form-field>
							<mat-label></mat-label>
							<input type="number" matInput [value]="getJours(mois)" min=0 max=getNbJoursMois(mois)
								(change)="update(mois, $event, true)" #txtInput (keydown.enter)="txtInput.blur()">
						</mat-form-field>
					</td>
				</tr>
			</tbody>
		</table>
		* Si non modifié, correspond au nombre de jours du mois

		<div class="statsLH-buttons">
			<button mat-raised-button (click)="refuse()" color="white">Retour</button>
			<button mat-raised-button [disabled]="loading" (click)="saveStatsLH()"
				class="button-spinner{{loading?'-loading':''}}" id="button">
				<mat-icon *ngIf="loading">
					<mat-spinner diameter="20"></mat-spinner>
				</mat-icon>Enregistrer
			</button>
		</div>
	</div>
</div>